import { Container } from '@cgs/wge';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import {
  T_GameStateMachineNotifierComponent,
  T_IFadeReelsProvider,
  T_ILogoAnimationProvider,
} from '../../type_definitions';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from '../components/game_state_machine_notifier_component';
import { ILogoAnimationProvider } from '../components/i_logo_animation_provider';
import { IFadeReelsProvider } from '../components/win_lines/i_fade_reels_provider';
import { GameStateMachineStates } from '../../reels_engine/state_machine/game-state-machine-states';

export abstract class ISlotAnimationController implements AbstractListener {
  abstract onStateEntered(slotState: string): void;
  abstract onStateExited(slotState: string): void;
  abstract attachChangesonStateEntered(slotState: string): void;
  abstract attachChangesonStateExited(slotState: string): void;
}

export class SlotAnimationController implements ISlotAnimationController {
  private _container: Container;
  private _stateMachine: GameStateMachine<any>;
  private _logoAnimationProvider: ILogoAnimationProvider | null;

  constructor(container: Container) {
    this._container = container;
    this._stateMachine = this._container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._logoAnimationProvider = this._container.resolve<ILogoAnimationProvider>(
      T_ILogoAnimationProvider,
      { optional: true }
    );
    const notifierComponent: GameStateMachineNotifierComponent =
      this._container.resolve<GameStateMachineNotifierComponent>(
        T_GameStateMachineNotifierComponent
      );
    notifierComponent.notifier.addListener(this);
  }

  attachChangesonStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Accelerate:
        this.OnAccelerateEntered();
        this.StopLogoAnimation();
        break;
      case GameStateMachineStates.Collapse:
        this.DisableFade();
        break;
      case GameStateMachineStates.EndOfFreeSpinsPopup:
        this.OnEndFreeSpinsPopup();
        break;
      case GameStateMachineStates.Bonus:
        this.OnBonusEntered();
        break;
    }
  }

  attachChangesonStateExited(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Bonus:
        this.OnBonusExited();
        this.DisableFade();
        break;
      case GameStateMachineStates.Scatter:
        this.DisableFade();
        break;
    }
  }

  onStateEntered(slotState: string): void {
    this.attachChangesonStateEntered(slotState);
  }

  onStateExited(slotState: string): void {
    this.attachChangesonStateExited(slotState);
  }

  private OnAccelerateEntered(): void {
    this.DisableFade();
  }

  private OnEndFreeSpinsPopup(): void {
    this.DisableFade();
  }

  private OnBonusEntered(): void {
    if (!this._stateMachine.curResponse.isFreeSpins) {
      this.DisableFade();
    }
  }

  private OnBonusExited(): void {
    if (!this._stateMachine.curResponse.isFreeSpins) {
      this.DisableFade();
    }
  }

  private DisableFade(): void {
    this._container.resolve<IFadeReelsProvider>(T_IFadeReelsProvider).enableFade(false);
  }

  private StopLogoAnimation(): void {
    if (this._logoAnimationProvider && !this._stateMachine.curResponse.freeSpinsInfo) {
      this._logoAnimationProvider.stopLogoAnimation();
    }
  }
}
